import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M20.4 13.733 14.933 19.2 11.6 16"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M25.466 7.867c-3.333-.267-6.266-1.6-8.666-3.6-.534-.4-1.2-.4-1.734 0-2.4 2-5.333 3.333-8.666 3.6C5.866 8 5.333 8.533 5.333 9.2v5.734c0 5.866 4.267 11.333 10 12.933.4.133.933.133 1.333 0 5.734-1.6 10-7.067 10-12.933V9.2c0-.667-.533-1.2-1.2-1.333"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }